import { cn } from '@/lib/utils';

/**
 * Kopfzeile einer Listenseite, die beim Scrollen oben stehen bleibt.
 *
 * Suche und Filter gehören zu einer langen Liste dazu: wer auf Zeile 200 die
 * Suche ändern will, sollte nicht erst wieder nach oben scrollen müssen.
 *
 * Die negativen Ränder heben das `p-6` des Scroll-Bereichs (AppShell → main)
 * wieder auf. Ohne `-mx-6 px-6` wäre die Kopfzeile schmaler als der Bereich,
 * an dem sie klebt, und der Inhalt liefe an den Seiten sichtbar vorbei.
 *
 * `-top-6` statt `top-0`, weil der Klebepunkt an der *Innen*kante des
 * `padding-top` liegt: mit `top-0` bliebe darüber ein 24px hoher Streifen, in
 * dem die Tabelle sichtbar durchläuft. Zusammen mit `-mt-6 pt-6` liegt die
 * Ruheposition dann genau auf der Klebeposition — die Kopfzeile springt beim
 * ersten Scrollen nicht.
 */
export function PageHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'sticky -top-6 z-20 -mx-6 -mt-6 mb-4 border-b border-border bg-background px-6 pb-4 pt-6',
        className,
      )}
    >
      {children}
    </div>
  );
}
